import {lerp} from '@colonist/utils'
// eslint-disable-next-line no-restricted-imports
import {audioManager, Sound} from '../../../../../code/client/shared/scripts/Sound.ts'

const diceRollPattern1: number[] = [1, 4, 3, 2, 4, 3, 1, 4, 2, 1, 4, 3, 1, 2, 4, 1, 2, 4, 3, 1, 3, 4, 2, 4, 1, 3, 1, 4]
const diceRollPattern2: number[] = [2, 1, 4, 3, 4, 1, 2, 3, 1, 3, 2, 4, 3, 1, 4, 3, 4, 2, 1, 2, 4, 2, 3, 1, 2, 4, 3, 1]
const diceRollPattern3: number[] = [1, 2, 3, 4, 2, 4, 1, 2, 3, 4, 1, 2, 4, 3, 2, 1, 3, 2, 4, 1, 2, 1, 4, 2, 3, 1, 4, 2]
let diceRollPatternIndex = 0

// Random dice sound functions
export function playDiceSound(diceNumber: number, isMyPlayersTurn: boolean) {
    const tableNumber = window.location.hash.charCodeAt(1) % 3
    const assignedDiceRollPattern = initializeDiceRollPattern(tableNumber)
    const currentPlayerDiceVolume = 1.0
    const otherPlayerDiceVolume = 0.6
    const relativeDiceVolume = isMyPlayersTurn ? currentPlayerDiceVolume : otherPlayerDiceVolume

    // Create a distribution where 7 is 1.0 playbackSpeed, 2 is 0.92 pbS and 12 is 1.08 pbS [1 +- 0.08]
    const lowestPitch = 0.92
    const highestPitch = 1.08
    const lowestPossibleDiceValue = 2
    const highestPossibleDiceValue = 12
    // Calculate interpolation factor (0-1) based on dice number position in range
    const t = (diceNumber - lowestPossibleDiceValue) / (highestPossibleDiceValue - lowestPossibleDiceValue)
    const dicePitch = lerp(lowestPitch, highestPitch, t)
    switch(assignedDiceRollPattern[diceRollPatternIndex]) {
        case 1:
            audioManager.play(Sound.SoundType.DiceRoll1, relativeDiceVolume, dicePitch)
            break
        case 2:
            audioManager.play(Sound.SoundType.DiceRoll2, relativeDiceVolume, dicePitch)
            break
        case 3:
            audioManager.play(Sound.SoundType.DiceRoll3, relativeDiceVolume, dicePitch)
            break
        case 4:
            audioManager.play(Sound.SoundType.DiceRoll4, relativeDiceVolume, dicePitch)
            break
        default:
            audioManager.play(Sound.SoundType.DiceRoll1, relativeDiceVolume, dicePitch)
            break
    }
    diceRollPatternIndex = diceRollPatternIndex + 1
    if(diceRollPatternIndex > assignedDiceRollPattern.length - 1) diceRollPatternIndex = 0
}

export function initializeDiceRollPattern(tableNumber: number): number[] {
    switch(tableNumber) {
        case 0:
            return diceRollPattern1
        case 1:
            return diceRollPattern2
        case 2:
            return diceRollPattern3
        default:
            return diceRollPattern1
    }
}
